import React from 'react';

import List from './Views/List/Index';
import Context from './Context';

export default function Index() {
  return (
    <Context>
      <List />
    </Context>
  );
}
